export const questions = [
  {
    question: 'How are monthly active users defined?',
    answer:
      'A user is considered active if they participate in at least one campaign or request within the month.',
  },
  {
    question: "What's my billing date?",
    answer:
      'Your billing date is set to the day your 14-day trial ends, or if you sign up after the trial, on that signup date.',
  },
  {
    question: 'Is there a contract?',
    answer:
      'No, you are never locked into a contract. Our goal is to deliver continuous value with our reputation marketing platform.',
  },
  {
    question: 'Where can I get my bills?',
    answer: 'Invoices can be downloaded directly from your customer portal.',
  },
];
